import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap';

import { SettingsService } from '../../shared/settings/settings.service';
import { PagetitleService } from '../../core/pagetitle/pagetitle.service';

import { AuthService }      from 'ng2-ui-auth';
import { Router }           from '@angular/router';
import {TranslateService} from 'ng2-translate/ng2-translate';
import {ConfigService} from '../../services/configuracion/config.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss', './header.menu-links.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent implements OnInit {

  sidebarVisible: true;
  sidebarOffcanvasVisible: boolean;
  languages = [];

  constructor(
    private settings: SettingsService,
    private pt: PagetitleService,
    private auth: AuthService,
    private router: Router,
    private translate: TranslateService,
    public config: ConfigService
   ) {
    console.log(config.defaultLanguage, config.languages, translate.getBrowserLang());
    // this.changeLanguage(config.defaultLanguage);
  }

  ngOnInit() {
  }

  toggleSidebarOffcanvasVisible() {
    this.settings.app.sidebar.offcanvasVisible = !this.settings.app.sidebar.offcanvasVisible;
  }

  toggleSidebar(state) {
    //  state === true -> open
    //  state === false -> close
    //  state === undefined -> toggle
    this.settings.app.sidebar.visible = typeof state !== 'undefined' ? state : !this.settings.app.sidebar.visible;

    document.body.className = 'theme-imm';
  }

  openModalSearch() {

  }

  openModalBar() {

  }

  logout() {
    console.log(this.auth);
    console.log(this.auth.getPayload());

    this.auth.logout();
    this.router.navigateByUrl('login');
  }

  changeLanguage(lang) {
    this.languages = this.config.languages;
    this.config.defaultLanguage = lang;
    this.translate.setDefaultLang(lang);
    this.translate.use(lang);
    this.translate.reloadLang(lang);

    // const index = this.languages.indexOf(lang);
    // if (index !== -1) {
    //   this.languages.splice(index, 1);
    // }
  }
}



// WEBPACK FOOTER //
// ./src/app/layout/header/header.component.ts